import {css} from 'lit'; export default css`.input-file{display:none}`;
    